import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'

export default function useUsersList() {
  // Use toast
  const toast = useToast()

  const refEmailAddressListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'email', label: 'E-Mail Adresi', sortable: true },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalEmailAddress = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)
  const categoryData = ref({ name: '' })

  const dataMeta = computed(() => {
    const localItemsCount = refEmailAddressListTable.value ? refEmailAddressListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEmailAddress.value,
    }
  })

  const refetchData = () => {
    refEmailAddressListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchEmailCategories = (ctx, callback) => {
    store
      .dispatch('app-email/fetchEmailAddress', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
        category_id: router.currentRoute.params.category_id,
      })
      .then(response => {
        const { emails } = response.data.data
        categoryData.value = response.data.data.category
        const { total } = response.data.meta

        callback(emails)
        totalEmailAddress.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching email Address list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchEmailCategories,
    tableColumns,
    perPage,
    currentPage,
    categoryData,
    totalEmailAddress,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refEmailAddressListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
